var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.9996 0.0029428C116.391 0.00295004 149.999 33.6112 149.999 75.0026L149.999 150.002L74.9996 150.002C33.6082 150.002 -2.03504e-05 116.394 -1.31133e-05 75.0025C-5.87625e-06 33.6111 33.6082 0.00293556 74.9996 0.0029428Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6117 47.2222C10.581 47.2222 0.000667572 36.6418 0.000667572 23.6112V0.000183105H23.6117C36.6423 0.000183105 47.2227 10.5806 47.2227 23.6112C47.2227 36.6418 36.6423 47.2222 23.6117 47.2222Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4_2",
    d: "M27.1615 27.4803V13.75H24.0866L15 27.6171V29.6678H24.7765V33.7498H27.1615V29.6678H29.9999V27.4803H27.1615ZM24.54 16.8945H24.7765V27.4803H17.7004V27.3241L24.54 16.8945Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M99.4097 73.6272C99.4097 59.7231 88.1315 48.4448 74.2273 48.4448C62.4484 48.4448 52.5587 56.5304 49.81 67.4497L43.1035 85.6045H48.5726V91.867C48.5726 95.702 51.6803 98.8096 55.5153 98.8096H61.3149V117.805H87.7347V94.8802C94.753 90.4123 99.4097 82.5724 99.4097 73.6272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M87.7345 118.74H61.3052C60.7857 118.74 60.3607 118.315 60.3607 117.795V99.7445H55.5055C51.1605 99.7445 47.6183 96.2024 47.6183 91.8573V86.5393H43.1033C42.7915 86.5393 42.5082 86.3882 42.3287 86.1332C42.1492 85.8781 42.1114 85.557 42.2154 85.2642L48.9029 67.1566C51.85 55.5856 62.2498 47.5 74.227 47.5C88.6318 47.5 100.354 59.2222 100.354 73.627C100.354 82.4304 95.9995 90.5254 88.6791 95.39V117.805C88.6791 118.324 88.254 118.749 87.7345 118.749V118.74ZM62.2593 116.851H86.7899V94.8705C86.7899 94.5493 86.9505 94.2471 87.2244 94.0771C94.2615 89.5998 98.4649 81.9487 98.4649 73.627C98.4649 60.2612 87.5928 49.3892 74.227 49.3892C63.0999 49.3892 53.4369 56.908 50.726 67.6856C50.726 67.7234 50.7071 67.7517 50.6976 67.7801L44.4634 84.6596H48.5723C49.0919 84.6596 49.5169 85.0847 49.5169 85.6042V91.8573C49.5169 95.1633 52.209 97.8554 55.515 97.8554H61.3147C61.8342 97.8554 62.2593 98.2804 62.2593 98.7999V116.851Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M117.679 73.6267C117.679 59.7226 106.401 48.4443 92.4968 48.4443C80.718 48.4443 70.8283 56.5299 68.0795 67.4492L61.373 85.604H66.8421V91.8665C66.8421 95.7015 69.9498 98.8091 73.7848 98.8091H79.5845V117.805H106.004V94.8797C113.022 90.4119 117.679 82.5719 117.679 73.6267Z",
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M106.938 118.74H78.6293V99.7445H73.7742C69.4291 99.7445 65.887 96.2024 65.887 91.8573V86.5393H60.0117L67.1716 67.1566C70.1092 55.5856 80.5185 47.5 92.4957 47.5C106.9 47.5 118.623 59.2222 118.623 73.627C118.623 82.4304 114.268 90.5254 106.948 95.39V118.749L106.938 118.74ZM80.5185 116.851H105.049V94.351L105.484 94.0771C112.521 89.5998 116.724 81.9487 116.724 73.627C116.724 60.2612 105.852 49.3892 92.4862 49.3892C81.3591 49.3892 71.6961 56.908 68.9852 67.6856L68.9569 67.7801L62.7227 84.6596H67.7761V91.8667C67.7761 95.1728 70.4682 97.8648 73.7742 97.8648H80.5185V116.86V116.851Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M116.734 97.54L114.09 100.197L116.733 102.855L119.378 100.198L116.734 97.54Z",
    fill: "#F7D979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M116.754 103.347C116.625 103.347 116.509 103.295 116.419 103.204L113.776 100.547C113.583 100.353 113.583 100.055 113.776 99.8604L116.406 97.2035C116.587 97.022 116.909 97.022 117.09 97.2035L119.733 99.8604C119.926 100.055 119.926 100.353 119.733 100.547L117.09 103.204C116.999 103.295 116.883 103.347 116.754 103.347ZM114.794 100.197L116.754 102.167L118.714 100.197L116.754 98.2274L114.794 100.197Z",
    fill: "#705699"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M105.049 116.852H80.5185V97.8658H73.7742C70.4682 97.8658 67.7761 95.1737 67.7761 91.8677V84.6701H62.7227L68.9852 67.6866C71.6961 56.9184 81.3686 49.3901 92.4863 49.3901C105.852 49.3901 116.724 60.2622 116.724 73.628C116.724 81.9591 112.521 89.6007 105.484 94.078L105.049 94.3614V116.861V116.852ZM82.4076 114.963H103.16V93.3224L104.473 92.4817C110.962 88.3539 114.835 81.3074 114.835 73.628C114.835 61.3012 104.813 51.2793 92.4863 51.2793C82.2282 51.2793 73.3208 58.2125 70.8177 68.1494L70.7232 68.4422L65.4241 82.7809H69.6558V91.8772C69.6558 94.1442 71.4978 95.9861 73.7648 95.9861H82.3982V114.972L82.4076 114.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.6293 106.809H36.8711V108.698H39.6293V106.809Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M45.0218 106.809H42.2637V108.698H45.0218V106.809Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.4144 106.809H47.6562V108.698H50.4144V106.809Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M39.6315 62.6946H37.925C37.5131 62.6946 37.1895 62.3719 37.1895 61.9613C37.1895 61.5507 37.5131 61.228 37.925 61.228H39.6315C40.0434 61.228 40.367 61.5507 40.367 61.9613C40.367 62.3719 40.0434 62.6946 39.6315 62.6946Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M44.3541 62.6946H42.6477C42.2358 62.6946 41.9121 62.3719 41.9121 61.9613C41.9121 61.5507 42.2358 61.228 42.6477 61.228H44.3541C44.766 61.228 45.0897 61.5507 45.0897 61.9613C45.0897 62.3719 44.766 62.6946 44.3541 62.6946Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M41.134 61.1999C40.7221 61.1999 40.3984 60.8773 40.3984 60.4667V58.7655C40.3984 58.3549 40.7221 58.0322 41.134 58.0322C41.5459 58.0322 41.8695 58.3549 41.8695 58.7655V60.4667C41.8695 60.8773 41.5459 61.1999 41.134 61.1999Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M41.134 65.907C40.7221 65.907 40.3984 65.5843 40.3984 65.1737V63.4725C40.3984 63.0619 40.7221 62.7393 41.134 62.7393C41.5459 62.7393 41.8695 63.0619 41.8695 63.4725V65.1737C41.8695 65.5843 41.5459 65.907 41.134 65.907Z",
    fill: "#6AD1EA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M99.6475 64.002C99.5247 64.4742 93.5645 77.0466 93.5645 77.0466L99.1375 75.8658L98.5518 83.158L105.258 69.8678L99.043 71.1807L99.6475 64.002Z",
    fill: "#FF6161"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet4);
export default __webpack_public_path__ + "static/media/item_tablet_4.5cd5a9b57a7a3037723ffd106d05fcba.svg";
export { ForwardRef as ReactComponent };